module.exports = __webpack_public_path__ + "img/1440.2f9cb213.jpg";